<template>
  <div>
    <service-quest-list :category="2" :param="param"></service-quest-list>
  </div>
</template>

<script>
import ServiceQuestList from './list'

export default {
  components: { ServiceQuestList },
  data() {
    return {
      param: {
        statuses: [3, 100],
      },
    }
  },
}
</script>